<template>
  <PDrawer
    :model-value="helpStore.showHelpDrawer"
    drawer-class="drawer pb-0"
    title="Need Help?"
    @update:model-value="helpStore.closeDrawer"
    @before-open="reset"
  >
    <template #content-wrapper>
      <div ref="container" class="h-full overflow-hidden">
        <HelpMain
          v-if="!helpStore.formMode"
          :is-ticket-created="createdTicket"
          @form-mode-changed="helpStore.changeFormMode($event)"
        />
        <HelpForm
          v-else
          :mode="helpStore.formMode"
          @cancel="ticketCreated(false)"
          @ticket-created="ticketCreated"
          @error="scrollTop"
        />
      </div>
    </template>
    <template #footer-wrapper>
      <div></div>
    </template>
  </PDrawer>
</template>

<script setup lang="ts">
import { PDrawer } from '@pequity/squirrel';
import { ref } from 'vue';
import HelpForm from '@/help/components/help-form.vue';
import HelpMain from '@/help/components/help-main.vue';
import { useHelpStore } from '@/stores/help';

defineOptions({
  name: 'HelpWidget',
});

// Data
const createdTicket = ref(false);
const helpStore = useHelpStore();
const container = ref<HTMLDivElement | null>(null);

// Methods
const ticketCreated = (isCreated: boolean) => {
  createdTicket.value = isCreated;
  helpStore.changeFormMode('');
};

const reset = () => {
  helpStore.changeFormMode('');
  createdTicket.value = false;
};

const scrollTop = () => {
  container.value?.scroll({ top: 0, behavior: 'smooth' });
};
</script>
